import Ajax from '../js/common/ajax';
import Qs from "qs";
/**
 * 资产相关接口
 */
export default {
//资产类别
    assetsType: {
        list() {
            return Ajax.get("/assets-type")
        },
        load(id) {
            return Ajax.get(`/assets-type/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/assets-type/${id}`)
        },
        save(params = {}) {
            return Ajax.post(`/assets-type`, params)
        },
        update(params = {}) {
            return Ajax.put(`/assets-type`, params)
        }
    },
    //资产
    assets: {
        list() {
            return Ajax.get("/assets")
        },
        load(id) {
            return Ajax.get(`/assets/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/assets/${id}`)
        },
        save(params = {}) {
            return Ajax.post(`/assets`, params)
        },
        update(params = {}) {
            return Ajax.put(`/assets`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/assets/batch-update`, params)
        }
    },
    //折旧
    depreciation: {
        list() {
            return Ajax.get("/depreciation")
        },
        load(id) {
            return Ajax.get(`/depreciation/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/depreciation/${id}`)
        },
        save(params = {}) {
            return Ajax.post(`/depreciation`, params)
        },
        update(params = {}) {
            return Ajax.put(`/depreciation`, params)
        }
    },
    //资产处置
    disposal: {
        list() {
            return Ajax.get("/detail")
        },
        load(id) {
            return Ajax.get(`/detail/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/detail/${id}`)
        },
        save(params = {}) {
            return Ajax.post(`/detail`, params)
        },
        update(params = {}) {
            return Ajax.put(`/detail`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/detail/batch-update`, params)
        }
    },
}